import { I18nComponente } from "@/types/gerais"

export const OCriarEventoi18n: I18nComponente = {
  "pt-BR": {
    lancarAtividadeDe: "lançar atividade de:",
    profissionalQueRealizou: "profissional que realizou*",
    dataDeInicio: "data de inicio",
    dataDeFim: "data de fim",
    horarioDeInicio: "horário de inicio",
    horarioDeFim: "horário de fim",
    quantidade: "quantidade",
    projetos: "projetos",
    cancelar: "cancelar",
    salvar: "salvar",
    salvarAlteracoes: "salvar alterações",
    confirmar: "confirmar",
    oProfissionalNaoFoiEncontrado: "O profissional não foi encontrado",
    oUsuarioQueEstaAtualmenteLogado: "O usuário que está atualmente logado não possui um profissional associado. Você não pode lançar atividades sem um profissional",
    atividadeNaoEncontrada: "atividade não encontrada",
    aAtividadeComId: "a atividade com o id",
    naoFoiEncontrada: "não foi encontrada",
    atividadeLancadaComSucesso: "Atividade lançada com sucesso",
    naoFoiPossivelLancarAtividade: "Não foi possível lançar a atividade",
    atividadeAtualizadaComSucesso: "Atividade atualizada com sucesso",
    naoFoiPossivelAtualizarAtividade: "não foi possível atualizar a atividade",
    dadosDaAtividade: "dados da atividade",
    erroAoBuscarAtributos: "Erro ao buscar atributos",
    ocorreuUmErroAoBuscarAtributos: "Ocorreu um erro ao buscar atributos",
    etapaAtividade: "Etapa da atividade",
    etapaAtributos: "Etapa dos atributos",
  },
  "es-CO": {
    lancarAtividadeDe: "lanzar actividad de:",
    profissionalQueRealizou: "profesional que realizó*",
    dataDeInicio: "fecha de inicio",
    dataDeFim: "fecha de fin",
    horarioDeInicio: "hora de inicio",
    horarioDeFim: "hora de fin",
    quantidade: "cantidad",
    projetos: "proyectos",
    cancelar: "cancelar",
    salvar: "guardar",
    confirmar: "confirmar",
    salvarAlteracoes: "guardar cambios",
    oProfissionalNaoFoiEncontrado: "El profesional no fue encontrado",
    oUsuarioQueEstaAtualmenteLogado: "El usuario que está actualmente logado no tiene un profesional asociado. No puedes lanzar actividades sin un profesional",
    atividadeNaoEncontrada: "actividad no encontrada",
    aAtividadeComId: "la actividad con el id",
    naoFoiEncontrada: "no fue encontrada",
    atividadeLancadaComSucesso: "Actividad lanzada con éxito",
    naoFoiPossivelLancarAtividade: "No fue posible lanzar la actividad",
    atividadeAtualizadaComSucesso: "Actividad actualizada con éxito",
    naoFoiPossivelAtualizarAtividade: "no fue posible actualizar la actividad",
    dadosDaAtividade: "datos de la actividad",
    erroAoBuscarAtributos: "Error al buscar atributos",
    ocorreuUmErroAoBuscarAtributos: "Ocorreu um erro ao buscar atributos",
    etapaAtividade: "Etapa da atividade",
    etapaAtributos: "Etapa dos atributos",
  }
}
